/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Link_ConflictInputs */



/**
* | output |
* | --- |
* | "This calendar is already connected to a different Wundo account. Disconnect it there first, or connect a different calendar." |
*
* @param {Connections_Link_ConflictInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_link_conflict = /** @type {((inputs?: Connections_Link_ConflictInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Link_ConflictInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze agenda is al gekoppeld aan een ander Wundo-account. Koppel ze daar eerst los, of koppel een andere agenda.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet agenda est déjà connecté à un autre compte Wundo. Déconnectez-le d'abord là-bas, ou connectez un autre agenda.")
	return /** @type {LocalizedString} */ ("This calendar is already connected to a different Wundo account. Disconnect it there first, or connect a different calendar.")
});